/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback, useState, useEffect } from 'react'
import { Loader, Datagrid } from '@refera/ui-web'
import HeaderTitle from '_/components/header-title'
import useStyles, { datagridStyle } from './styles'
import { navigate } from '@reach/router'
import { Grid } from '@material-ui/core'
import {
  deleteAreaOfActivity,
  getAreaOfActivityList,
  getAreasOfActivityMeta,
  patchAreaOfActivity,
} from '_/modules/areaOfActivity/actions'
import { useDispatch, useSelector } from 'react-redux'
import {
  areasOfActivityListSelector,
  areaOfActivityMetaSelector,
} from '_/modules/areaOfActivity/selectors'
import { useToast } from '_/hooks/use-toast'
import { AreaOfActivityCRUDModal } from './components/CRUDModal'
import { useDialog } from '_/hooks/use-dialog'
import { AreasOfActivityColumns } from './constants'

export function AreaOfActivity() {
  const areasOfActivityList = useSelector(areasOfActivityListSelector)
  const areaOfActivityMeta = useSelector(areaOfActivityMetaSelector)
  const dispatch = useDispatch()
  const { showToast } = useToast()
  const { showDialog, closeDialog } = useDialog()
  const styles = useStyles()

  const [isLoading, setIsLoading] = useState(false)
  const [selectedId, setSelectedId] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)

  const selectedElement = selectedId
    ? areasOfActivityList.find(area => area.id === selectedId)
    : null

  const handleBackNavigation = useCallback(() => {
    return navigate('/')
  }, [navigate])

  async function fetchAreasOfActivity() {
    try {
      setIsLoading(true)
      await Promise.all([dispatch(getAreaOfActivityList()), dispatch(getAreasOfActivityMeta())])
    } catch (error) {
      console.error('Error fetching areas of activity:', error)
      showToast({ type: 'error' })
    } finally {
      setIsLoading(false)
    }
  }

  const handleEditAreaOfActivity = useCallback(event => {
    setSelectedId(event.row.id)
    setModalOpen(true)
  }, [])

  const onCloseModal = useCallback(() => {
    setModalOpen(false)
    setSelectedId(null)
  }, [])

  const handleSubmit = useCallback(
    async data => {
      try {
        setIsLoading(true)
        if (selectedId) {
          // Update existing area of activity
          await dispatch(patchAreaOfActivity(selectedId, data))
        }
        onCloseModal()
        showToast({ type: 'success' })
        fetchAreasOfActivity()
      } catch (error) {
        setIsLoading(false)
        showToast({ type: 'error', message: error?.error_message })
      }
    },
    [selectedId, dispatch, showToast, onCloseModal]
  )

  const handleDelete = useCallback(async () => {
    if (!selectedId) return

    showDialog({
      type: 'warning',
      subject: 'Você tem certeza que deseja excluir este registro?',
      labelApprove: 'Sim',
      labelCancel: 'Não',
      onApprove: async () => {
        closeDialog()
        try {
          setIsLoading(true)
          await dispatch(deleteAreaOfActivity(selectedId, { active: false }))
          onCloseModal()
          showToast({ type: 'success', message: 'Área de atuação excluída com sucesso.' })
          fetchAreasOfActivity()
        } catch (error) {
          setIsLoading(false)
          showToast({ type: 'error', message: error?.error_message })
        }
      },
      onCancel: closeDialog,
    })
  }, [selectedId, dispatch, showToast, onCloseModal])

  useEffect(() => {
    !areasOfActivityList.length && fetchAreasOfActivity()
  }, [])

  return (
    <>
      <Loader open={isLoading} hasBackdrop />
      <HeaderTitle title="Áreas de Atuação" backButtonAction={handleBackNavigation} />

      <Grid className={styles.tableContainer}>
        <Grid className={styles.mainTable}>
          <Datagrid
            loading={isLoading}
            rows={areasOfActivityList}
            columns={AreasOfActivityColumns()}
            sx={datagridStyle}
            onRowClick={handleEditAreaOfActivity}
            checkboxSelection={false}
            disableSelectionOnClick
          />
        </Grid>
      </Grid>
      <AreaOfActivityCRUDModal
        open={modalOpen}
        onClose={onCloseModal}
        onSubmit={handleSubmit}
        onDelete={handleDelete}
        item={selectedElement}
        meta={areaOfActivityMeta}
        loading={isLoading}
      />
    </>
  )
}
